"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var styles = function styles(theme) {
  return "\n.vds-icon,.vds-icon--low {\n  fill: ".concat(theme && theme.vds && theme.vds.secondary ? theme.vds.secondary : "#003ea9", ";\n  height: 24px;\n  width: 24px;\n}\n\n.vds-icon--high {\n  fill: ").concat(theme && theme.vds && theme.vds.secondary ? theme.vds.secondary : "#003ea9", ";\n  height: 48px;\n  width: 48px;\n}\n\n.vds-icon--tiny {\n  fill: ").concat(theme && theme.vds && theme.vds.secondary ? theme.vds.secondary : "#003ea9", ";\n  height: 16px;\n  width: 16px;\n}\n\na [class^=vds-icon] {\n  fill: ").concat(theme && theme.vds && theme.vds.linkColor ? theme.vds.linkColor : "#0051dc", ";\n  height: 1em;\n  width: 1em;\n}\n\na:hover [class^=vds-icon] {\n  fill: ").concat(theme && theme.vds && theme.vds.linkColorHover ? theme.vds.linkColorHover : "#0051dc", ";\n  height: 1em;\n  width: 1em;\n}");
};

var _default = styles;
exports.default = _default;